import localforage from 'localforage'

const RESET_FLAG = 'ec-store-reset-pending'
const LOG_PREFIX = '[store-reset]'

/**
 * Reset du store persisté uniquement si ?reset= est présent dans l'URL.
 * (ex. reset=cockpit, reset=gestionnaire)
 */
export function shouldResetStore (route) {
  return !!(route && route.query && route.query.reset !== undefined)
}

/**
 * Vide localStorage + localforage puis recharge une seule fois
 * (flag sessionStorage pour éviter une boucle).
 *
 * @param {string|number} [reason] valeur de ?reset= (ex. cockpit)
 * @returns {Promise<{reloading: boolean}>}
 */
export async function resetPersistedStore (reason) {
  if (sessionStorage.getItem(RESET_FLAG)) {
    sessionStorage.removeItem(RESET_FLAG)
    console.info(`${LOG_PREFIX} reprise après reload — cache déjà nettoyé`, reason != null ? `(reset=${reason})` : '')
    return { reloading: false }
  }

  try {
    console.info(`${LOG_PREFIX} démarrage`, reason != null ? `reset=${reason}` : '')

    const localKeys = Object.keys(window.localStorage)
    console.info(`${LOG_PREFIX} localStorage → ${localKeys.length} clé(s) à supprimer`, localKeys)

    sessionStorage.setItem(RESET_FLAG, '1')
    window.localStorage.clear()
    console.info(`${LOG_PREFIX} localStorage vidé`)

    const localforageKeys = await localforage.keys()
    console.info(`${LOG_PREFIX} localforage → ${localforageKeys.length} clé(s) à supprimer`, localforageKeys)

    await localforage.clear()
    console.info(`${LOG_PREFIX} localforage vidé — rechargement`)

    window.location.reload()
    return { reloading: true }
  } catch (error) {
    sessionStorage.removeItem(RESET_FLAG)
    console.error(`${LOG_PREFIX} échec du reset persisté`, error)
    return { reloading: false }
  }
}
